/**
 * Helper utility to format and sanitize image URLs (especially GitHub raw URLs with accents, spaces, or quotes)
 * and provide clean error fallbacks.
 */

export function getCleanImageUrl(url) {
  if (!url) return '';
  
  // If it's already a full http/https URL
  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      // Decode first in case parts are already encoded, then re-encode cleanly
      const parsed = new URL(url);
      const pathnameParts = parsed.pathname.split('/').map(part => {
        try {
          return encodeURIComponent(decodeURIComponent(part));
        } catch (e) {
          return encodeURIComponent(part);
        }
      });
      parsed.pathname = pathnameParts.join('/');
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }
  
  return url;
}

/**
 * Handle img onError event cleanly without infinite loops
 */
export function handleImageError(e, fallbackSrc = null) {
  const target = e.currentTarget;
  if (!target) return;
  
  // Prevent infinite loop if fallback also fails
  if (target.dataset.failed) return;
  target.dataset.failed = "true";

  if (fallbackSrc) {
    target.src = fallbackSrc;
  } else {
    // Transparent 1x1 GIF or default placeholder styling
    target.style.display = 'none';
  }
}
